import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OrderGroupDashboardPage" */
	'pages/supplier/OrderGroup/OrderGroupDashboardPage'));

export default [{ component, exact: true, path: '/order_groups/:orderGroupId' }];